import { render } from "./MediaList.vue?vue&type=template&id=2a2da3a8&scoped=true"
import script from "./MediaList.vue?vue&type=script&lang=js"
export * from "./MediaList.vue?vue&type=script&lang=js"

import "./MediaList.vue?vue&type=style&index=0&id=2a2da3a8&lang=postcss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a2da3a8"]])

export default __exports__